import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AnalyticsChartData } from '../types';

interface AnalyticsChartProps {
  title: string;
  description?: string;
  data: AnalyticsChartData;
  height?: number;
}

export function AnalyticsChart({ title, description, data, height = 300 }: AnalyticsChartProps) {
  // In a real implementation, this would use a charting library like Chart.js or Recharts
  // For this mock implementation, we'll create a simple visual representation
  
  const maxValue = Math.max(...data.datasets[0].data);
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent>
        <div style={{ height: `${height}px` }} className="w-full">
          <div className="flex h-full items-end gap-2">
            {data.datasets[0].data.map((value, index) => {
              // Only show every 3rd label to avoid overcrowding
              const showLabel = index % 3 === 0;
              const heightPercentage = (value / maxValue) * 100;
              
              return (
                <div key={index} className="flex flex-col items-center flex-1">
                  <div 
                    className="w-full bg-primary/20 rounded-t"
                    style={{ height: `${heightPercentage}%` }}
                  />
                  {showLabel && (
                    <div className="mt-2 text-xs text-muted-foreground truncate w-full text-center">
                      {data.labels[index]}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
